import { Icon } from '@iconify/react';

// There is no /api/visitors/stats endpoint, so these numbers come from two
// cheap limit=1 list probes in the saga. They are society-wide on purpose —
// they do not follow the filters below them, and undefined renders as an em
// dash rather than a misleading zero.
const CARDS = [
    { key: 'total', label: 'Total Visitors', icon: 'mdi:account-group-outline', bg: 'tw-bg-sky-50', text: 'tw-text-sky-600' },
    { key: 'active', label: 'Active', icon: 'mdi:account-check-outline', bg: 'tw-bg-emerald-50', text: 'tw-text-emerald-600' },
    { key: 'blocked', label: 'Blocked', icon: 'mdi:account-cancel-outline', bg: 'tw-bg-rose-50', text: 'tw-text-rose-600' },
];

const VisitorStats = ({ summary, loading = false, onShowBlocked, showBlockedCallout = false }) => (
    <>
        {/* Only three tiles across the full width, so the text sits at one edge
            and the icon at the other — packing both against the left leaves a
            dead half-card. Every <p> carries an explicit margin because
            Tailwind preflight is off project-wide and Bootstrap's reboot would
            otherwise add 1rem below each one. */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-4">
            {CARDS.map(card => {
                const value = summary?.[card.key];
                return (
                    <div
                        key={card.key}
                        className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-px-5 tw-py-4 tw-flex tw-items-center tw-justify-between tw-gap-4"
                    >
                        <div className="tw-min-w-0">
                            <p className="tw-mb-1.5 tw-text-[10px] tw-uppercase tw-tracking-wider tw-text-gray-500 tw-font-semibold tw-leading-none">
                                {card.label}
                            </p>
                            <p className="tw-mb-0 tw-text-2xl tw-font-bold tw-text-gray-800 tw-leading-none tw-tabular-nums">
                                {loading || value === undefined ? '—' : value}
                            </p>
                        </div>
                        <div className={`tw-w-11 tw-h-11 tw-rounded-lg ${card.bg} ${card.text} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                            <Icon icon={card.icon} className="tw-text-xl" />
                        </div>
                    </div>
                );
            })}
        </div>

        {showBlockedCallout && summary?.blocked > 0 && (
            <button
                onClick={onShowBlocked}
                className="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 tw-rounded-lg tw-bg-rose-50 tw-border tw-border-rose-100 tw-text-rose-800 tw-text-xs hover:tw-bg-rose-100 tw-transition-colors tw-text-left"
            >
                <Icon icon="mdi:shield-alert-outline" className="tw-text-base tw-shrink-0" />
                <span>
                    <strong>{summary.blocked}</strong> visitor{summary.blocked === 1 ? ' is' : 's are'} blocked at the gate.
                </span>
                <Icon icon="mdi:chevron-right" className="tw-text-base tw-ml-auto" />
            </button>
        )}
    </>
);

export default VisitorStats;
